import { useId } from "react";

/** The Navibiz mark: navy tile, chevron cut-out, amber waypoint. */
export function Logo({ size = 34 }: { size?: number }) {
  const mask = useId();
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden>
      <defs>
        <mask id={mask}>
          <rect x="8" y="8" width="84" height="84" rx="22" fill="#fff" />
          <path d="M30 61 L50 41 L70 61" fill="none" stroke="#000" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
        </mask>
      </defs>
      <rect x="8" y="8" width="84" height="84" rx="22" fill="#0F2A47" mask={`url(#${mask})`} />
      <circle cx="50" cy="25" r="6" fill="#E0A02D" />
    </svg>
  );
}
